import { useMutation, useQueryClient } from 'react-query';

import { axios } from 'src/lib/axios';
import { RestResponse } from 'src/types';

import { useUploadImage } from 'src/hooks';
import { CacheKey } from 'src/constants/cache-key';
import { Article, PublishContent } from 'src/app/article/types';
import useAuth from 'src/app/auth/use-auth';

type StudioRequest = PublishContent & { contentID: string };
type CreateStudioResponse = RestResponse<Article>;

export function useStudioMutation() {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  return useMutation(
    (values: StudioRequest) =>
      axios
        .post<CreateStudioResponse>('/studio', values)
        .then((res) => res.data),
    {
      onSuccess: (response, values) => {
        if (response.code === 1000) {
          const { contentID } = values;
          const updater = (prevCache) => ({
            ...prevCache,
            ...values,
            author: {
              userID: user.id,
            },
          });

          queryClient.setQueryData([CacheKey.article, contentID], updater);
        }
      },
    }
  );
}

export function useUploadCoverMutation(studioId: string) {
  const queryClient = useQueryClient();

  return useUploadImage(
    { areaType: 'STUDIO', id: studioId, imgType: 'studio_cover' },
    (response) => {
      const updater = (prevCache) => ({
        ...prevCache,
        coverImgURL: response.imgURL,
      });

      queryClient.setQueryData([CacheKey.article, studioId], updater);
    }
  );
}
